module.exports = __webpack_public_path__ + "static/garage_entrance_door_night_mobile-268abdce4fa41ec4310ac07c532ad254.jpg";